import { ui } from '@wp-g2/styles';
import React from 'react';
import { Grid } from '../Grid';
import { Select } from '../Select';
import { useColorPickerContext } from './ColorPicker.Context';
import { ColorPickerPreview } from './ColorPickerPreview';
export var ColorPickerSelect = /*#__PURE__*/React.memo(function () {
  var _useColorPickerContex = useColorPickerContext(),
      value = _useColorPickerContex.inputType,
      setInputType = _useColorPickerContex.setInputType,
      showPreview = _useColorPickerContex.showPreview;

  var handleOnChange = React.useCallback(function (next) {
    setInputType(next);
  }, [setInputType]);
  var templateColumns = showPreview ? "1fr " + ui.get('controlHeight') : '1fr';
  return /*#__PURE__*/React.createElement(Grid, {
    templateColumns: templateColumns
  }, /*#__PURE__*/React.createElement(Select, {
    onChange: handleOnChange,
    value: value
  }, /*#__PURE__*/React.createElement("option", {
    value: "hex"
  }, "Hex"), /*#__PURE__*/React.createElement("option", {
    value: "rgb"
  }, "RGB"), /*#__PURE__*/React.createElement("option", {
    value: "hsl"
  }, "HSL")), showPreview && /*#__PURE__*/React.createElement(ColorPickerPreview, null));
});